let obj = {
    username: '',
    first_name: '',
    last_name: '',
    email: '',
    image: ''
}
export default obj;